import { render, staticRenderFns } from "./num3.vue?vue&type=template&id=5ee4fde8&"
import script from "./num3.vue?vue&type=script&lang=js&"
export * from "./num3.vue?vue&type=script&lang=js&"
import style0 from "./num3.vue?vue&type=style&index=0&id=5ee4fde8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports